import { createFileRoute } from "@tanstack/react-router";
import { viewerIdentityAuthRoute } from "@/app-clients/viewer-identity-flow";

export const Route = createFileRoute("/api/auth/$")({
    ...viewerIdentityAuthRoute,
});
